<template>
  <page-header></page-header>

  <div class="innerBanner CouriersBanner position-relative">
    <div class="inBannerImg">
      <img src="../assets/couriers_img.png" alt="Couriers" />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6">
        <div class="innerBannerText">
          <h1 class="text-uppercase">DELIVERY AGENTS</h1>
          <p class="fw-bold mb-1">Drive with Postmedia Parcel Services</p>
          <p>
            Our business is one of the fastest growing businesses and services
            in today’s retail market. Be your own boss, increase your earning
            potential and enjoy a schedule that fits your lifestyle.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="intersted-bg w-100 position-relative">
    <div class="container-sm position-relative">
      <div class="row">
        <div class="col-lg-6 mx-auto text-center">
          <h2 class="text-uppercase text-black sub_heading mb-0">
            ARE YOU INTERESTED IN DRIVING FOR US?
          </h2>
          <p class="mt-1 mb-4">Click the button below to learn more about our parcel delivery opportunities.</p>
          <a
            href="#/careers"
            class="bg-white d-inline-block click-here-btn position-relative"
          >
            <img
              src="../assets/arrow.png"
              alt="arrow"
              class="img-fluid"
            />
            Click Here</a
          >
        </div>
      </div>
    </div>
  </div>

  <div class="our-team position-relative">
    <div class="container-sm">
      <div class="row">
        <div class="col-lg-12 mx-auto our-team-content text-center">
          <p class="text-black">
            Our team of delivery agents use the best delivery technology to make
            the job easy and efficient. From tracking updates to secure drop and
            confirmation, you’ll have exactly what you need to make quality
            deliveries to our customers. And, our customers never wonder where,
            what time, or in what condition their parcel was dropped off –
            because they know instantly.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="getInTouchSection">
    <div class="container-sm">
      <div class="getInTouch">
        <h5>
          <p>Need more information or support?</p>
          <a href="#/support" title=""
            >Get in touch with us today!</a
          >
        </h5>
      </div>
    </div>
  </div>

  <!-- Track Parcel page Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="p-4 fs-3">
            Proof of Delivery, review the delivery image
          </div>
        </div>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>
<script>
import PageFooter from "./PageFooter.vue";
import PageHeader from "./PageHeader.vue";

export default {
    beforeMount() {
    scroll(0,0)
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
};
</script>